import { Box, Flex, Img, Link } from "@chakra-ui/react";
import React from "react";

const OtherStat = () => {
  return (
    <>
      <Flex m="10px" justifyContent={"center"} gap="10px" >
        <Link href="https://github.com/utkarshqw">
          <Img
            align="center"
            src="https://github-readme-streak-stats.herokuapp.com/?user=utkarshqw"
            alt="*"
          />
        </Link>

        <Link target="_blank" href="https://leetcode.com/utkarsh_qw/">
          <Img src="https://leetcode.card.workers.dev/utkarsh_qw?theme=wtf&font=baloo&extension=null" />
        </Link>
      </Flex>

      <Flex
        gap="20px"
        justifyContent={"center"}
        m="5px"
        mt="20px"
        border="1px solid white"
        
      >
        <Link href="https://github.com/utkarshqw">
          <Img
            align="center"
            src="https://github-readme-stats.vercel.app/api/top-langs/?username=utkarshqw"
            alt="#"
          />
        </Link>

        <Link href="https://github.com/utkarshqw">
          <Img
            align="left"
            src="https://github-readme-stats.vercel.app/api?username=utkarshqw&count_private=true&show_icons=true"
            alt="#"
          />
        </Link>
      </Flex>
    </>
  );
};

export default OtherStat;
